import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-payment-popup',
    templateUrl: './payment-popup.component.html',
    styleUrl: './payment-popup.component.sass',
    standalone: false
})

export class PaymentPopupComponent {
 constructor(
    private dialogRef: MatDialogRef<PaymentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, classes?: string[]}
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
